module.exports = __webpack_public_path__ + "img/classic_3.49b3f0b4.jpg";